import { useLayoutEffect, useRef, useState } from 'react';

import measureListHeight from './measureListHeight';

const MAX_VISIBLE_ROWS = 10;

export default function useLockedListHeight({ loading, search }) {
  const listRef = useRef(null);
  const [height, setHeight] = useState(null);

  useLayoutEffect(() => {
    const isFiltered = search.trim() !== '';
    if (loading || isFiltered || height !== null) {
      return;
    }
    const container = listRef.current;
    const rows = Array.from(container.querySelector('ul')?.children ?? []);
    setHeight(
      measureListHeight({
        container,
        rows,
        contentHeight: container.scrollHeight,
        maxRows: MAX_VISIBLE_ROWS,
        availableHeight: measureAvailableHeight(container),
      })
    );
  }, [loading, search, height]);

  return { listRef, height };
}

// The dialog scrolls its own content once it hits its max height (short viewports). Give the
// list only the room that's left so there is one scrollbar, not two.
function measureAvailableHeight(container) {
  let scrollParent = container.parentElement;
  while (scrollParent && !/auto|scroll/.test(window.getComputedStyle(scrollParent).overflowY)) {
    scrollParent = scrollParent.parentElement;
  }
  const overflow = scrollParent ? scrollParent.scrollHeight - scrollParent.clientHeight : 0;
  if (overflow <= 0) {
    return Infinity;
  }
  // scrollHeight/clientHeight are rounded to whole pixels; the real overflow can be up to 1px more.
  return container.scrollHeight - overflow - 1;
}
